import fuelsReducer from "./fuelsReducer"
export default fuelsReducer